import Close from './icons/Close';
import css from './QuestionModal.module.scss';

export default function QuestionModal({ app, callback, isTC = false }: any) {
    return (
        <div className={`question-modal ${css['question-modal']}`}>
            <div className={`modal-content ${isTC ? 'tc' : ''}`}>
                <div className="modal-header">
                    <span className="close" onClick={callback}>
                        <Close />
                    </span>
                </div>
                <div className="modal-body">
                    {app?.title && <p className="modal-title">{app?.title}</p>}
                    <p className="modal-text">{app.text}</p>
                </div>
            </div>
            <style jsx global>
                {`
                    .announcement-bar {
                        z-index: 100;
                    }
                    .ecoflow-frame-header {
                        z-index: 150 !important;
                    }
                    .festival-float {
                        z-index: 180;
                    }
                `}
            </style>
        </div>
    );
}
